export default __webpack_public_path__ + "static/media/Avatar-21.8b171b7f.svg";